import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"

const paymentAdapter = createEntityAdapter()
export const initialState = paymentAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
})

export const selectFetchStatus = (state: RootState) =>
  state.features.payment.fetchStatus

export default paymentSlice.reducer
